module.exports = __webpack_public_path__ + "img/intro_title_1.a908524d.png";